import { Chip, Grid, Stack, Typography } from "@mui/material";
import ThinningObject from "../thinningObject";

type ActivityReference = { id: string; label: string };

type ActivityReferencesSectionProps = {
  translate: (key: string) => string;
  reduced: boolean;
  withLogging: boolean;
  disabled?: boolean;
  isSmallScreen: boolean;
  activityId: string;
  projectId: string;
  references: ActivityReference[];
  nonReferencedSpecies: any;
  standData: any;
  selectedFeature: any;
  features: any;
  thinningData: any;
  removedStandIds: string[];
  onUpdatedThinningData: (data: any, type: "referenced" | "non-referenced", userChange?: boolean) => void;
  onDeleteThinning: (id: string, standId: string) => void;
};

const ActivityReferencesSection = ({
  translate,
  reduced,
  withLogging,
  disabled,
  isSmallScreen,
  activityId,
  projectId,
  references,
  nonReferencedSpecies,
  standData,
  selectedFeature,
  features,
  thinningData,
  removedStandIds,
  onUpdatedThinningData,
  onDeleteThinning,
}: ActivityReferencesSectionProps) => {
  if (!reduced) {
    return (
      <Grid item xs={12}>
        <Typography color="secondary" sx={{ mb: -1, mt: -1 }}>
          {translate("project-activity-map-feature-references")}
        </Typography>

        <Stack direction="row" spacing={2}>
          <ThinningObject
            activityId={activityId}
            projectId={projectId}
            references={references}
            nonReferencedSpecies={nonReferencedSpecies}
            standData={standData}
            selectedFeature={selectedFeature}
            features={features}
            thinningData={thinningData}
            removedStandIds={removedStandIds}
            disabled={disabled}
            setUpdatedThinningData={onUpdatedThinningData}
            deleteThinning={onDeleteThinning}
          />
        </Stack>
      </Grid>
    );
  }

  return (
    <Grid item xs={12}>
      <Typography color="secondary" sx={{ mb: 0.5, mt: -1 }}>
        {translate("project-activity-map-feature-references")}
      </Typography>

      <Stack direction="row" spacing={2} sx={{ mt: 0.5 }}>
        {references.length === 0 && (
          <Chip
            label={translate("project-activity-map-feature-references-none")}
            variant="light"
            color="primary"
            size="small"
            disabled={disabled}
          />
        )}

        <Stack direction="row" spacing={2} sx={{ mr: -2, alignItems: "flex-start" }}>
          <Stack
            direction="row"
            sx={{
              flexWrap: references.length > 3 ? "wrap" : "intial",
              gap: 0.7,
              maxWidth: withLogging ? (isSmallScreen ? 56 : 200) : "100%",
            }}
          >
            {references.map((reference) => (
              <Chip
                key={reference.id}
                label={reference.label}
                variant="light"
                color="primary"
                size="small"
                disabled={disabled}
              />
            ))}
          </Stack>
        </Stack>
      </Stack>
    </Grid>
  );
};

export default ActivityReferencesSection;
